import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./api";
import { ToastProvider } from "./components/ui";
import "@fontsource-variable/inter";
import "./tokens.css";
import "./global.css";
import App from "./App";
const router = createBrowserRouter([{ path: "*", element: <ToastProvider><App /></ToastProvider> }]);
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
